var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t(
          "Webheader.connector_list_" +
            _vm.entitiesType +
            "_" +
            _vm.role +
            "_" +
            _vm.type
        ),
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                    [
                      _c("back-button", {
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "4", sm: "3", md: "2", xl: "1" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter",
                          attrs: { disabled: _vm.activateSpinner },
                          on: {
                            click: function ($event) {
                              return _vm.onRefresh()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-rotate-right fs-14px",
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("common.rfrsh")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-tabs",
                {
                  attrs: {
                    value: _vm.role == 0 ? 1 : 0,
                    "nav-class": "d-none",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 0 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.receiver") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _vm.activateSpinner
                                ? _c("spinner")
                                : _c(
                                    "div",
                                    [
                                      _vm.mqseriesCredentialFields.length
                                        ? _c("b-table", {
                                            staticClass: "mt-3 table-striped",
                                            attrs: {
                                              hover: "",
                                              relative: "",
                                              responsive: "",
                                              items: _vm.mqseriesCredentialList,
                                              fields:
                                                _vm.mqseriesCredentialFields,
                                              selectable: "",
                                              "select-mode": "single",
                                            },
                                            on: {
                                              "row-selected":
                                                _vm.seeMQSeriesCredentialDetails,
                                            },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "noResult" },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.no_result"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      class: _vm.role == 1 ? "d-none" : "",
                      attrs: { title: _vm.$t("common.routing.responder") },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _vm.activateSpinner
                                ? _c("spinner")
                                : _c(
                                    "div",
                                    [
                                      _vm.mqseriesFields.length
                                        ? _c("b-table", {
                                            staticClass:
                                              "mt-3 table-striped table-hover",
                                            attrs: {
                                              hover: "",
                                              relative: "",
                                              responsive: "",
                                              items: _vm.mqseriesConfigList,
                                              fields: _vm.mqseriesFields,
                                              selectable: "",
                                              "select-mode": "single",
                                            },
                                            on: {
                                              "row-selected":
                                                _vm.seeMQSeriesDetails,
                                            },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "noResult" },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.no_result"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }